export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./virtual-sports.vue?vue&type=template&id=3f0e6aa0"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/history/virtual-sports.vue?vue&type=template&id=3f0e6aa0
// module id = 63G4
// module chunks = 0